/*
 *
 * SubrouteHeader
 *
 * @version 1.0.0
 * @author Marco Civello
 * @since 26-Nov-2024
 */

import { defineMessages } from 'react-intl'

const formattedMessage = {}

export const messages = defineMessages({
  close: {
    id: 't.app.project.btn.close',
    defaultMessage: 'Close'
  },
  back: {
    id: 't.app.project.btn.back',
    defaultMessage: 'Back'
  },
  step: {
    id: 't.app.project.step',
    defaultMessage: 'Step'
  }
})

export default formattedMessage
